// src/store/slices/houseToolsSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchHouseToolsSummaryThunk = createAsyncThunk(
  "houseTools/summary",
  async (home_id, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/house-tools/summary/${home_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

export const resetReceiptsThunk = createAsyncThunk(
  "houseTools/resetReceipts",
  async (home_id, { rejectWithValue }) => {
    try {
      const res = await api.post(`/api/house-tools/reset-receipts/${home_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

export const resetBalanceThunk = createAsyncThunk(
  "houseTools/resetBalance",
  async (home_id, { rejectWithValue }) => {
    try {
      const res = await api.post(`/api/house-tools/reset-balance/${home_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const houseToolsSlice = createSlice({
  name: "houseTools",
  initialState: {
    summary: null,
    loading: false,
    resettingReceipts: false,
    resettingBalance: false,
    error: null,
    success: null,
  },
  reducers: {
    clearHouseToolsMsg: (s) => {
      s.error = null;
      s.success = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchHouseToolsSummaryThunk.pending, (s) => {
      s.loading = true;
      s.error = null;
      s.success = null;
    });
    b.addCase(fetchHouseToolsSummaryThunk.fulfilled, (s, a) => {
      s.loading = false;
      s.summary = a.payload || null;
    });
    b.addCase(fetchHouseToolsSummaryThunk.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload || "Failed";
    });

    b.addCase(resetReceiptsThunk.pending, (s) => {
      s.resettingReceipts = true;
      s.error = null;
      s.success = null;
    });
    b.addCase(resetReceiptsThunk.fulfilled, (s, a) => {
      s.resettingReceipts = false;
      s.success = a.payload?.message || "Receipts reset";
    });
    b.addCase(resetReceiptsThunk.rejected, (s, a) => {
      s.resettingReceipts = false;
      s.error = a.payload || "Failed";
    });

    b.addCase(resetBalanceThunk.pending, (s) => {
      s.resettingBalance = true;
      s.error = null;
      s.success = null;
    });
    b.addCase(resetBalanceThunk.fulfilled, (s, a) => {
      s.resettingBalance = false;
      s.success = a.payload?.message || "Balance reset";
    });
    b.addCase(resetBalanceThunk.rejected, (s, a) => {
      s.resettingBalance = false;
      s.error = a.payload || "Failed";
    });
  },
});

export const { clearHouseToolsMsg } = houseToolsSlice.actions;
export default houseToolsSlice.reducer;
